import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-checkout-header',
  standalone: true,
  imports: [],
  templateUrl: './checkout-header.component.html',
  styleUrl: './checkout-header.component.scss'
})
export class CheckoutHeaderComponent implements OnChanges {
  @Input() name: string;
  @Input() total: number;

  totalCorrectNum = 0;
  totalFractions = '00';
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.total) {
      this.totalCorrectNum = Math.floor(this.total);
      const fractions = Math.round(this.total % 1 * 100);
      this.totalFractions = fractions < 10 ? '0' + fractions : fractions.toString();
    }
  }
}
